<div class="d-flex flex-wrap align-items-center {{ cssClass }}">
  <label class="switch me-2">
    <input type="checkbox" (change)="toggle()" [checked]="value" />
    <span class="slider round"></span>
  </label>

  <ng-content />
</div>
